import {da} from "date-fns/locale";

export const formatDate = (date: any): string | undefined => {
  if (date && date != undefined && date != '') {
    const d: Date = new Date(date);
    const pad = (n: number): string => String(n).padStart(2, '0');

    const dateString: string = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const hour: number = d.getHours();
    const minutes: number = d.getMinutes();
    const seconds: number = d.getSeconds();

    if (hour || minutes || seconds) {
      return `${dateString} ${pad(hour)}:${pad(minutes)}:${pad(seconds)}`;
    }
    return dateString;
  }
  return undefined;
};

export const formatDateToDateTime = (date: Date): string => {
  let year: number = date.getFullYear();
  let month: number | string = date.getMonth();
  if (month < 10) month = `0${month}`;

  let day: number | string = date.getDate();
  if (day < 10) day = `0${day}`;

  return `${year}-${month}-${day}T00:00`
};
